module.exports = __webpack_public_path__ + "static/yellow-vest-between-two-trucks-e71ab93b3fa54d8b081f5643a310e8d5.jpg";